import React from "react";
import { AppFieldWithLabelAndError } from "./AppTypography";

const EyeIcon = ({ showSlash = false }) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.25 5.72C16.94 2.09 13.56 0 10 0C8.22 0 6.49 0.52 4.91 1.49C3.33 2.47 1.91 3.9 0.75 5.72C-0.25 7.29 -0.25 9.84 0.75 11.41C3.06 15.05 6.44 17.13 10 17.13C11.78 17.13 13.51 16.61 15.09 15.64C16.67 14.66 18.09 13.23 19.25 11.41C20.25 9.85 20.25 7.29 19.25 5.72ZM10 12.61C7.76 12.61 5.96 10.8 5.96 8.57C5.96 6.34 7.76 4.53 10 4.53C12.24 4.53 14.04 6.34 14.04 8.57C14.04 10.8 12.24 12.61 10 12.61Z"
        fill="#131A22"
      />
      <path
        d="M10.0004 5.71002C8.43039 5.71002 7.15039 6.99002 7.15039 8.57002C7.15039 10.14 8.43039 11.42 10.0004 11.42C11.5704 11.42 12.8604 10.14 12.8604 8.57002C12.8604 7.00002 11.5704 5.71002 10.0004 5.71002Z"
        fill="#131A22"
      />
      {showSlash && (
        <line
          x1="2"
          y1="2"
          x2="18"
          y2="16"
          stroke="#131A22"
          strokeWidth="2"
          strokeLinecap="round"
        />
      )}
    </svg>
  );
};

const AppInput = ({
  id,
  label,
  value,
  type = "text",
  onChange,
  onInput,
  placeholder,
  disabled = false,
  children,
  error,
  mandatory = false,
  required = false,
  inputContainerProps = {},
  inputProps = {},
  maxLength,
  showCount = false,
  name = "",
}) => {
  const [showPassword, setShowPassword] = React.useState(false);
  return (
    <AppFieldWithLabelAndError
      label={label}
      required={required || mandatory}
      error={error}
    >
      <div
        {...inputContainerProps}
        className={`
          flex items-center rounded-xl border bg-white px-3 py-2 gap-2
          transition focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-500 focus-within:border-blue-500
          ${disabled ? "bg-gray-50 border-gray-200" : "bg-white"}
          ${error ? "border-red-500" : "border-gray-300"} 
          ${inputContainerProps.className || ""}
        `}
      >
        <input
          id={id}
          type={showPassword ? "text" : type}
          value={value || ""}
          onChange={onChange}
          onInput={onInput}
          placeholder={placeholder}
          disabled={disabled}
          name={name}
          maxLength={maxLength}
          className="flex-1 bg-transparent text-sm text-gray-700
          placeholder-gray-400 outline-none"
          {...inputProps}
        />

        {
          showCount &&
          <label className="text-14px text-gray-400">
            {`${value?.length || 0} / ${maxLength}`}
          </label>
        }

        {type === "password" && (
          <button
            type="button"
            style={{ cursor: "pointer", color: "#131A22" }}
            onClick={() => setShowPassword(!showPassword)}
          >
            <EyeIcon showSlash={showPassword} />
          </button>
        )}

        {/* Right side content (button / icon) */}
        {children}
      </div>
      
    </AppFieldWithLabelAndError>
  );
};

export default AppInput;
